/**
 * @flow
 */
import { Box, Button, SvgIcon, Typography } from '@mui/material';
import AnswerBar from 'components/@home/drawers/FormAnalyticsDrawer/AnswerBar';
import QuestionTypeIcon from 'components/@home/drawers/FormDrawer/QuestionTypeIcon';
import { Confirm, confirmOptions } from 'components/@home/drawers/FormDrawer/questionTypes';
import isEmpty from 'lodash/isEmpty';
import ChevronRightIcon from 'mdi-react/ChevronRightIcon';
import React from 'react';
import { I18n } from 'utils/i18n';

type Props = {
  question: Object,
  summary: Object,
  index: number,
  showAnswers: Function,
};

const QuestionSummary = ({ question, index, summary, showAnswers }: Props) => {
  const opts =
    question.type === Confirm
      ? confirmOptions.map(([_id, label]) => ({ _id, label }))
      : Object.values(question.options || {});
  const options = opts.map(({ _id, label }: Object) => ({
    _id,
    label,
    users: summary.users || 0,
    count: summary.answers[_id],
    pct: summary.users ? (summary.answers[_id] / summary.users) * 100 : 0,
  }));
  return (
    <Box
      sx={theme => ({
        borderRadius: '8px',
        p: '30px 20px',
        display: 'flex',
        flexDirection: 'column',
        mb: '10px',
        border: `1px solid ${theme.palette.secondary.extraLight}`,
      })}
    >
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ fontSize: 18, mr: '20px' }}>
          <QuestionTypeIcon type={question.type} text={`${index + 1}`} />
        </Box>
        <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          <Typography sx={{ fontSize: 15, lineHeight: '22px', fontWeight: 500 }}>
            {question.title}
          </Typography>
          <Box sx={{ mt: '10px' }}>
            {!isEmpty(options) ? (
              options.map(option => (
                <Box key={option._id} sx={{ display: 'flex', flexGrow: 1 }}>
                  <AnswerBar option={option} />
                  <Button
                    variant="text"
                    sx={{
                      width: 180,
                      display: 'flex',
                      alignItems: 'center',
                      background: 'none',
                      m: '5px',
                    }}
                    onClick={() => showAnswers(question, option._id)}
                  >
                    <Typography
                      sx={{
                        width: '3em',
                        textAlign: 'right',
                        mr: '0.5em',
                        justifyContent: 'flex-end',
                      }}
                    >
                      {option.pct.toFixed()}%
                    </Typography>
                    <Typography sx={{ display: 'flex', alignItems: 'center' }}>
                      (
                      {I18n.t('FormAnalyticsDrawer.responses', {
                        count: option.count,
                      })}
                      )
                      <SvgIcon>
                        <ChevronRightIcon />
                      </SvgIcon>
                    </Typography>
                  </Button>
                </Box>
              ))
            ) : (
              <Button
                variant="text"
                onClick={() => showAnswers(question)}
                sx={{
                  width: 180,
                  display: 'flex',
                  alignItems: 'center',
                  background: 'none',
                  m: '5px',
                }}
              >
                <Typography sx={{ display: 'flex', alignItems: 'center' }}>
                  {I18n.t('FormAnalyticsDrawer.responses', {
                    count: summary.users,
                  })}
                  <SvgIcon>
                    <ChevronRightIcon />
                  </SvgIcon>
                </Typography>
              </Button>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default QuestionSummary;
